import React from 'react';

import { Grid, Typography } from '@mui/material';

import { SxProp } from 'src/types/mui';

import { ChangePasswordForm } from './ChangePasswordForm';

interface FormContentProps {
  switchClosability: (isClosureAllowed: boolean) => void;
  onSubmitCallback: () => void;
}

export const FormContent: React.FC<FormContentProps> = ({
  onSubmitCallback,
  switchClosability,
}) => {
  return (
    <Grid container>
      <Grid mb={1} size={12}>
        <Typography variant="h2" sx={titleStyles}>
          Set up new password
        </Typography>
      </Grid>
      <Grid mb={4} sx={subtitleStyles} size={12}>
        <Typography variant="body2" color="text.secondary">
          Confirm current password and type in new one
        </Typography>
      </Grid>
      <Grid size={12}>
        <ChangePasswordForm
          onSubmitCallback={onSubmitCallback}
          switchClosability={switchClosability}
        />
      </Grid>
    </Grid>
  );
};

const titleStyles: SxProp = {
  fontSize: '24px',
};

const subtitleStyles: SxProp = theme => ({
  fontSize: '16px',
  color: theme.palette.grey['800'],
});
